import { encodeUid } from '@shared/helpers';
import { ProductReference, StateUtils } from '@spartacus/core';
import { PRODUCT_GROUP_REFERENCES } from '../product-state';

export const LOAD_PRODUCT_GROUP_REFERENCES = '[CustomCatalog] Load Product Group References Load';
export const LOAD_PRODUCT_GROUP_REFERENCES_SUCCESS = '[CustomCatalog] Load Product Group References Load Success';
export const LOAD_PRODUCT_GROUP_REFERENCES_FAIL = '[CustomCatalog] Load Product Group References Load Fail';
export const PRODUCT_GROUP_REFERENCES_RESET = '[CustomCatalog] Product Group References Load Reset';

export class LoadProductGroupReferences extends StateUtils.EntityLoadAction {
  readonly type = LOAD_PRODUCT_GROUP_REFERENCES;

  constructor(
    public productCode: string,
    public referenceType: string,
    public categoryCode: string,
    public pageSize?: number,
  ) {
    super(PRODUCT_GROUP_REFERENCES, encodeUid(productCode, referenceType, categoryCode));
  }
}

export class LoadProductGroupReferencesSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_PRODUCT_GROUP_REFERENCES_SUCCESS;

  constructor(
    public productCode: string,
    public referenceType: string,
    public categoryCode: string,
    public payload: ProductReference[],
  ) {
    super(PRODUCT_GROUP_REFERENCES, encodeUid(productCode, referenceType, categoryCode), payload);
  }
}

export class LoadProductGroupReferencesFail extends StateUtils.EntityFailAction {
  readonly type = LOAD_PRODUCT_GROUP_REFERENCES_FAIL;

  constructor(
    public productCode: string,
    public referenceType: string,
    public categoryCode: string,
    payload: any,
  ) {
    super(PRODUCT_GROUP_REFERENCES, encodeUid(productCode, referenceType, categoryCode), payload);
  }
}

export class ProductGroupReferencesReset extends StateUtils.EntityRemoveAllAction {
  readonly type = PRODUCT_GROUP_REFERENCES_RESET;

  constructor() {
    super(PRODUCT_GROUP_REFERENCES);
  }
}

export type ProductGroupReferencesAction =
  | LoadProductGroupReferences
  | LoadProductGroupReferencesSuccess
  | LoadProductGroupReferencesFail
  | ProductGroupReferencesReset;
